import { useQuery } from "@tanstack/react-query";
import { Card, MIN_MODAL_CONTENT_HEIGHT, PieChart } from "components";
import { useMemo, useState } from "react";
import {
  ChartExport,
  useExportableChart,
} from "../../../../../../../../shared/components";
import { Props } from "../../../../WebAnalytics.types";
import { getAccountsMonitoredInIntent } from "../../Visualization.requests";

export const CustomersMonitoredWithIntent = ({
  pixelId,
  accountView,
  campaignId,
  startDate,
  endDate,
  accountsIds,
  visitedPages,
  includeIspTraffic,
  includeKnownBotTraffic,
  includePotentialBotTraffic,
  personas,
}: Props) => {
  const { data: rawData, isFetching: isFetching } = useQuery({
    queryKey: [
      "webAnalyticsAccountsMonitoredInIntent",
      pixelId,
      accountView,
      campaignId,
      startDate,
      endDate,
      accountsIds,
      visitedPages,
      includeIspTraffic,
      includeKnownBotTraffic,
      includePotentialBotTraffic,
    ],
    queryFn: () =>
      getAccountsMonitoredInIntent(pixelId, {
        accountView,
        campaignId,
        startDate,
        endDate,
        accountsIds,
        visitedPages,
        includeIspTraffic,
        includeKnownBotTraffic,
        includePotentialBotTraffic,
        personas,
      }),
  });

  const [isExpanded, setIsExpanded] = useState(false);

  const data = useMemo(() => {
    if (isFetching || !rawData?.data) {
      return [];
    }

    return rawData.data.map(({ category, countAccounts }) => ({
      label: category,
      value: Number(countAccounts),
    }));
  }, [rawData, isFetching]);

  const chart = useExportableChart({
    title:
      data[0]?.value > data[1]?.value
        ? "Your Buying Group Is more likely to visit your site from accounts with intent"
        : "Your Buying Group Is less likely to visit your site from accounts with intent",
    campaignId: campaignId || undefined,
    chart: (
      <PieChart
        minHeight={isExpanded ? MIN_MODAL_CONTENT_HEIGHT : undefined}
        stretch
        legendPosition="bottom"
        data={data}
        displayAsPercent={true}
      />
    ),
    dates: {
      start: startDate,
      end: endDate,
    },
  });

  return (
    <Card
      onExpandedChange={setIsExpanded}
      isLoading={isFetching}
      title={chart.title}
      hasData={!isFetching && Boolean(data?.length)}
      isExpandable
      actions={
        <ChartExport
          size="small"
          campaignId={campaignId || undefined}
          title={chart.title}
          onExportPNG={chart.downloadAsPng}
          data={data}
        />
      }
    >
      {chart.component}
      {chart.exportComponent}
    </Card>
  );
};
